export const ebisInterfaceMonitoringMaintenanceRequiredFieldList: string[] = [
    'ebisInterfaceMonitoring',
];

export const EbisInterfaceMonitoringMaintenanceConstant = {
    CATEGORY: "Interface Monitoring",
    TITLE: "Ebis Interface Monitoring",
    MESSAGE_TYPE: "Message Type",
    STATUS: 'Status',
    FROM: 'From',
    TO: 'To',
    DATE_RANGE: 'Date Range',
    DATE_FROM: 'Date (From)',
    DATE_TO: 'Date (To)',
    SEND_RECEIVE_DATE: 'Send/Receive Date',
    BATBCH_NAME: 'Batch Name',
    FILE_NAME: 'File Name',
    ERROR_MESSAGE: 'Error Message',
    SEARCH_CRITERIA: 'Search Criteria',

    Detail: {
        TITLE: "Ebis Interface Monitoring Detail",
        //CCGLIN
        SET_OF_BOOKS_ID: "Set of Books Id",
        ACCOUNTING_DATE: "Accounting Date",
        CURRENCY_CODE: "Currency Code",
        DATE_CREATED: "Date Created",
        CREATED_BY: "Created By",
        ACTUAL_FLAG: "Actual Flag",
        USER_JE_CATEGORY_NAME: "User Je Category Name",
        USER_JE_SOURCE_NAME: "User Je Source Name",
        CURRENCY_CONVERSION_DATE: "Currency Conversion Date",
        USER_CURRENCY_CONVERSION_TYPE: "User Currency Conversion Type",
        CURRENCY_CONVERSION_RATE: "Currency Conversion Rate",
        ENTERED_DR: "Entered Dr.",
        ENTERED_CR: "Entered Cr.",
        ACCOUNTED_CR: "Accounted Cr.",
        ACCOUNTED_DR: "Accounted Dr.",
        REFERENCE1: "Reference1",
        REFERENCE2: "Reference2",
        REFERENCE4: "Reference4",
        REFERENCE5: "Reference5",
        REFERENCE6: "Reference6",
        REFERENCE7: "Reference7",
        REFERENCE8: "Reference8",
        REFERENCE10: "Reference10",
        SEGMENT1_PK: "Segment1 (PK)",
        SEGMENT2_PK: "Segment2 (PK)",
        SEGMENT3_PK: "Segment3 (PK)",
        SEGMENT4_PK: "Segment4 (PK)",
        SEGMENT5_PK: "Segment5 (PK)",
        SEGMENT6_PK: "Segment6 (PK)",
        SEGMENT7_PK: "Segment7 (PK)",
        SEGMENT8_PK: "Segment8 (PK)",
        SEGMENT9_PK: "Segment9 (PK)",
        PERIOD_NAME: "Period Name",
        BUDGET_VERSION_ID: "Budget Version Id",
        ATTRIBUTE1: "Attribute1",
        ATTRIBUTE2: "Attribute2",
        ATTRIBUTE3: "Attribute3",
        ATTRIBUTE4: "Attribute4",
        ATTRIBUTE5: "Attribute5",
        ATTRIBUTE6: "Attribute6",
        ATTRIBUTE7: "Attribute7",
        ATTRIBUTE8: "Attribute8",
        ATTRIBUTE9: "Attribute9",
        ATTRIBUTE10: "Attribute10",
        CONTEXT: "Context",
        //SLARDS
        INTERFACE_DISTRIBUTION_ID: "Interface Distribution Id",
        INTERFACE_LINE_ID: "Interface Line Id",
        INTERFACE_LINE_CONTEXT: "Interface Line Context",
        INTERFACE_LINE_ATTRIBUTE1: "Interface Line Attribute1",
        INTERFACE_LINE_ATTRIBUTE2: "Interface Line Attribute2",
        INTERFACE_LINE_ATTRIBUTE3: "Interface Line Attribute3",
        INTERFACE_LINE_ATTRIBUTE4: "Interface Line Attribute4",
        INTERFACE_LINE_ATTRIBUTE5: "Interface Line Attribute5",
        INTERFACE_LINE_ATTRIBUTE6: "Interface Line Attribute6",
        INTERFACE_LINE_ATTRIBUTE7: "Interface Line Attribute7",
        INTERFACE_LINE_ATTRIBUTE8: "Interface Line Attribute8",
        ACCOUNT_CLASS: "Accounting Class",
        AMOUNT: "Amount",
        PERCENT: "Percent",
        SEGMENT1: "Segment1",
        SEGMENT2: "Segment2",
        SEGMENT3: "Segment3",
        SEGMENT4: "Segment4",
        SEGMENT5: "Segment5",
        SEGMENT6: "Segment6",
        SEGMENT7: "Segment7",
        SEGMENT8: "Segment8",
        SEGMENT9: "Segment9",
        DOC_CREATION_BY: "Doc Created By",
        DOC_CREATION_DATE: "Doc Created Date",
        DOC_LAST_UPDATED_BY: "Doc Last Updated By",
        DOC_LAST_UPDATED_DATE: "Doc Last Updated Date",
        ORG_ID: "Org Id",
        ATTRIBUTE_CATEGORY: "Attribute Category",
        //SLARLN
        BATCH_SOURCE_NAME: "Batch Source Name",
        LINE_TYPE: "Line Type",
        DESCRIPTION: "Description",
        CUST_TRX_TYPE_NAME: "Cust Trx Type Name",
        TERM_NAME: "Term Name",
        ORIG_SYSTEM_BILL_CUSTOMER_REF: "Orig System Bill Customer Ref.",
        ORIG_SYSTEM_BILL_ADDRESS_REF: "Orig System Bill Address Ref.",
        ORIG_SYSTEM_BILL_CONTAC_REF: "Orig System Bill Contac Ref.",
        ORIG_SYSTEM_SHIP_CUSTOMER_REF: "Orig System Ship Contac Ref.",
        ORIG_SYSTEM_SHIP_ADDRESS_REF: "Orig System Ship Address Ref.",
        ORIG_SYSTEM_SHIP_CONTAC_REF: "Orig System Ship Contac Ref.",
        ORIG_SYSTEM_SOLD_CUSTOMER_REF: "Orig System Sold Contac Ref.",
        LINK_TO_LINE_CONTEXT: "Link To Line Context",
        LINK_TO_LINE_ATTRIBUTE1: "Link To Line Attribute1",
        LINK_TO_LINE_ATTRIBUTE2: "Link To Line Attribute2",
        LINK_TO_LINE_ATTRIBUTE3: "Link To Line Attribute3",
        LINK_TO_LINE_ATTRIBUTE4: "Link To Line Attribute4",
        LINK_TO_LINE_ATTRIBUTE5: "Link To Line Attribute5",
        LINK_TO_LINE_ATTRIBUTE6: "Link To Line Attribute6",
        LINK_TO_LINE_ATTRIBUTE7: "Link To Line Attribute7",
        RECEIPT_METHOD_NAME: "Receipt Method Name",
        CONVERSION_TYPE: "Conversion Type",
        CONVERSION_DATE: "Conversion Date",
        CONVERSION_RATE: "Conversion Rate",
        TRX_DATE: "Trx Date",
        GL_DATE: "Gl Date",
        DOCUMENT_NUMBER: "Document Number",
        TRX_NUMBER: "Trx Number",
        LINE_NUMBER: "Line Number",
        QUANTITY_ORDERED: "Quantity Ordered",
        UNIT_SELLING_PRICE: "Unit Selling Price",
        REFERENCE_LINE_CONTEX: "Reference Line Context",
        REFERENCE_LINE_ATTRIBUTE1: "Reference Line Attribute1",
        REFERENCE_LINE_ATTRIBUTE2: "Reference Line Attribute2",
        REFERENCE_LINE_ATTRIBUTE3: "Reference Line Attribute3",
        REFERENCE_LINE_ATTRIBUTE4: "Reference Line Attribute4",
        REFERENCE_LINE_ATTRIBUTE5: "Reference Line Attribute5",
        REFERENCE_LINE_ATTRIBUTE6: "Reference Line Attribute6",
        REFERENCE_LINE_ATTRIBUTE7: "Reference Line Attribute7",
        REFERENCE_LINE_ATTRIBUTE8: "Reference Line Attribute8",
        CREDIT_METHOD_FOR_ACCT_RULE: "Credit Method For Acct Rule",
        CREDIT_METHOD_FOR_INSTALLMENTS: "Credit Method For Installments",
        REASON_CODE: "Reason Code",
        TAX_RATE: "Tax Rate",
        TAX_CODE: "Tax Code",
        TAX_PERCEDENCE: "Tax Percedence",
        SHIP_DATE_ACTUAL: "Ship Date Actual",
        FOB_POINT: "FobPoint",
        SHIP_VIA: "Ship Via",
        WAYBILL_NUMBER: "Waybill Number",
        INVOICING_RULE_NAME: "Invoicing Rule Name",
        ACCOUNT_RULE_NAME: "Account Rule Name",
        ACCOUNT_RULE_DURATION: "Accounting Rule Duration",
        RULE_START_DATE: "Rule Start Date",
        PRIMARY_SALESREP_NUMBER: "Primary Salesrep Number",
        SALES_ORDER: "Sales Order",
        SALES_ORDER_LINE: "Sales Order Line",
        SALES_ORDER_DATE: "Sales Order Date",
        SALES_ORDER_SOURCE: "Sales Order Source",
        SALES_ORDER_REVISION: "Sales Order Revision",
        AGREEMENT_NAME: "Agreement Name",
        MEMO_LINE_NAME: "Memo Line Name",
        CUSTOMER_BANK_ACCOUNT_NAME: "Customer Bank Account Name",
        UOM_NAME: "UOM Name",
        TAX_EXEMPT_REASON_CODE: "Tax Exempt Reason Code",
        TAX_EXEMPT_NUMBER: "Tax Exempt Number",
        DOC_CREATED_BY: "Doc Created By",
        DOC_CREATED_DATE: "Doc Created Date",
        HEADER_ATTRIBUTE1: "Header Attribute1",
        HEADER_ATTRIBUTE2: "Header Attribute2",
        HEADER_ATTRIBUTE3: "Header Attribute3",
        HEADER_ATTRIBUTE4: "Header Attribute4",
        HEADER_ATTRIBUTE5: "Header Attribute5",
        HEADER_ATTRIBUTE6: "Header Attribute6",
        HEADER_ATTRIBUTE7: "Header Attribute7",
        HEADER_ATTRIBUTE8: "Header Attribute8",
        HEADER_ATTRIBUTE9: "Header Attribute9",
        HEADER_ATTRIBUTE10: "Header Attribute10",
        HEADER_ATTRIBUTE11: "Header Attribute11",
        HEADER_ATTRIBUTE12: "Header Attribute12",
        HEADER_ATTRIBUTE13: "Header Attribute13",
        HEADER_ATTRIBUTE14: "Header Attribute14",
        HEADER_ATTRIBUTE15: "Header Attribute15",
        HEADER_ATTRIBUTE_CATEGORY: "Header Attribute Category",
        COMMENTS: "Comments",
        GLOBAL_ATTRIBUTE_CATEGORY: "Global Attribute Category",
        GLOBAL_ATTRIBUTE1: "Global Attribute1",
        GLOBAL_ATTRIBUTE2: "Global Attribute2",
        GLOBAL_ATTRIBUTE3: "Global Attribute3",
        GLOBAL_ATTRIBUTE4: "Global Attribute4",
        GLOBAL_ATTRIBUTE5: "Global Attribute5",
        GLOBAL_ATTRIBUTE6: "Global Attribute6",
        GLOBAL_ATTRIBUTE7: "Global Attribute7",
        GLOBAL_ATTRIBUTE8: "Global Attribute8",
        GLOBAL_ATTRIBUTE9: "Global Attribute9",
        GLOBAL_ATTRIBUTE10: "Global Attribute10",
        //SLARRE
        SHIPPING_LINE: "Shipping Line",
        INVOICE_NO: "Invoice No.",
        INVOICE_DATE: "Invoice Date",
        INVOICE_AMOUNT: "Invoice Amount",
        CREDIT_NOTE_NO: "Credit Note No.",
        CREDIT_NOTE_DATE: "Credit Note Date",
        CREDIT_NOTE_AMOUNT: "Credit Note Amount",
        RECEIPT_CHEQUE_NO: "Receipt No./Cheque No.",
        RECEIPT_CHEQUE_DATE: "Cheque Date",
        RECEIPT_CHEQUE_AMOUNT: "Cheque Amount",
        TAX_CHALLEN_NO: "Tax Challen No.",
        TAX_CHALLEN_DATE: "Tax Challen Date",
        TAX_CHALLEN_AMOUNT: "Tax Challen Amount",
        BALANCE_AMOUNT: "Balance Amount",
        REMARKS: "Remarks",
    }
}
